import api from "./api";

export const currentAccountsService = {
  list(params) {
    return api.get("/current-accounts", { params });
  },
  get(id) {
    return api.get(`/current-accounts/${id}`);
  },
  create(payload) {
    return api.post("/current-accounts", payload);
  },
  update(id, payload) {
    return api.patch(`/current-accounts/${id}`, payload);
  },
  listMovements(id, params) {
    return api.get(`/current-accounts/${id}/movements`, { params });
  },
  balancesReport(params) {
    return api.get("/current-accounts/reports/balances", { params });
  },
  createMovement(id, payload) {
    return api.post(`/current-accounts/${id}/movements`, payload);
  },

  createDeposit(id, payload) {
    return api.post(`/current-accounts/${id}/deposits`, payload);
  },

  payDebt(id, payload) {
    return api.post(`/current-accounts/${id}/pay-debt`, payload);
  },

  listReceipts(id) {
    return api.get(`/current-accounts/${id}/receipts`);
  },
  commercialHistory(id, params) {
    return api.get(`/current-accounts/${id}/commercial-history`, { params });
  },
  legacyDocumentItems(id, documentId) {
    return api.get(`/current-accounts/${id}/legacy-documents/${documentId}/items`);
  },
  legacyOrderItems(id, orderId) {
    return api.get(`/current-accounts/${id}/legacy-orders/${orderId}/items`);
  },
};
